import React, { useEffect, useState } from 'react'
import { fetchData } from '../../../config/APIcall'
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Container } from '@mui/system';
import { usersUrl, columns_users } from '../../../constants/const';


const DataDisplay = () => {

    const [pageState, setPageState] = useState({
        isLoading: false,
        data: [],
        total:0
        
    })

    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 5,  
      });
    
    const getData = async () => {
        console.log('ON')
        setPageState((old)=>({...old,isLoading:true}))
        const res=await fetchData(usersUrl,paginationModel.page+1,paginationModel.pageSize)
        
        setPageState((old)=>({...old,data:res.data,total:res.total,isLoading:false}))
        
    }
    useEffect(() => {
        getData();
    }, [paginationModel.page, paginationModel.pageSize])
   
  

    return (
        <>
            <Container sx={{marginTop:"5rem"}}>
             
                <Typography variant='h4' component='h4' sx={{alignItems:"center",textAlign:'center'}}>
                    Users of Resreq
                </Typography>
                <Box sx={{ height: 400, width: 'fit-content' ,margin:"auto"}}>
                <DataGrid
                    rows={pageState.data}
                    columns={columns_users}
                    rowCount={pageState.total}
                    loading={pageState.isLoading}
                    pageSizeOptions={[5,10,15]}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                />
                </Box>
                
            </Container>

        </>
    )
}

export default DataDisplay



